import { dark as darkAsset, light as lightAsset } from './assets';

const dark = { key: 'dark', title: 'Tema Dark', url: darkAsset };
const light = { key: 'light', title: 'Tema Light', url: lightAsset };

export { dark, light };
export default [dark, light];
